import React from 'react';
export function InstantAccessSection() {
  const items = [{
    emoji: '📥',
    text: 'PDFs listos para imprimir'
  }, {
    emoji: '⚡',
    text: 'Acceso inmediato al material'
  }, {
    emoji: '🔄',
    text: 'Actualizaciones gratuitas'
  }, {
    emoji: '📱',
    text: 'Legible en cualquier dispositivo'
  }];
  return <section className="py-20 px-4 bg-[#f4ece1]" data-id="element-82">
      <div className="max-w-4xl mx-auto text-center" data-id="element-83">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-12" data-id="element-84">
          📲 ¿Qué recibís inmediatamente?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-85">
          {items.map((item, i) => <div key={i} className="bg-white rounded-2xl p-5 flex items-center justify-center gap-3 shadow-sm border border-white/50" data-id="element-86">
              <span className="text-2xl" data-id="element-87">{item.emoji}</span>
              <span className="font-bold text-brand-text" data-id="element-88">{item.text}</span>
            </div>)}
        </div>

        <p className="text-2xl font-serif italic text-brand-red font-bold" data-id="element-89">
          Cubrís el material de todo el año escolar
        </p>
      </div>
    </section>;
}